import { Button, Stack, TextField } from '@mui/material';
import { useManagerPinInputProps } from '@/components/useManagerPinInputProps';

export function NegotiatedPricePinPrompt({
  draftPin,
  disabled,
  onDraftChange,
  onApply,
}: {
  draftPin: string;
  disabled: boolean;
  onDraftChange: (value: string) => void;
  onApply: () => void;
}) {
  const pinInputProps = useManagerPinInputProps(draftPin, onDraftChange);
  return (
    <Stack spacing={1}>
      <TextField
        label="Override PIN for this transaction"
        required
        fullWidth
        size="small"
        {...pinInputProps}
        disabled={disabled}
        helperText="One PIN applies to all negotiated prices in this transaction."
      />
      <Button
        variant="outlined"
        onClick={onApply}
        disabled={disabled || draftPin.trim().length === 0}
        sx={{ alignSelf: 'flex-start' }}
      >
        Apply negotiated price
      </Button>
    </Stack>
  );
}
